namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHd1Form {
        PromoCampaign: Serenity.LookupEditor;
        PmGroupId: Serenity.StringEditor;
        PmGroupDesc: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.RadioButtonEditor;
        StartPromoTime: Common.EditTimeEditor;
        EndPromoTime: Common.EditTimeEditor;
        PromoDayFg: Serenity.RadioButtonEditor;
        PromoDay: Serenity.LookupEditor;
        PromoShopFg: Serenity.RadioButtonEditor;
        PromoShop: Serenity.LookupEditor;
        PromoCustFg: Serenity.EnumEditor;
        PromoMb: Serenity.LookupEditor;
        PromoStatus: Serenity.BooleanEditor;
        PromoApproveFg: Serenity.BooleanEditor;
        VenderSharing: Serenity.DecimalEditor;
        ItemList: PsAdvPromoItemEditor;
        ItemExList: PsAdvPromoItemExemptEditor;
    }

    export class PsAdvPromoHd1Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoHd1';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoHd1Form.init)  {
                PsAdvPromoHd1Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = Common.EditTimeEditor;
                var w5 = s.EnumEditor;
                var w6 = s.BooleanEditor;
                var w7 = s.DecimalEditor;
                var w8 = PsAdvPromoItemEditor;
                var w9 = PsAdvPromoItemExemptEditor;

                Q.initFormType(PsAdvPromoHd1Form, [
                    'PromoCampaign', w0,
                    'PmGroupId', w1,
                    'PmGroupDesc', w1,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w4,
                    'EndPromoTime', w4,
                    'PromoDayFg', w3,
                    'PromoDay', w0,
                    'PromoShopFg', w3,
                    'PromoShop', w0,
                    'PromoCustFg', w5,
                    'PromoMb', w0,
                    'PromoStatus', w6,
                    'PromoApproveFg', w6,
                    'VenderSharing', w7,
                    'ItemList', w8,
                    'ItemExList', w9
                ]);
            }
        }
    }
}
